/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { createEntity, getEntity, reset, updateEntity } from './post-op-surgeon-notes.reducer';

export const PostOPSurgeonNotesUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const postOPSurgeonNotesEntity = useAppSelector(state => state.postOPSurgeonNotes.entity);
  const loading = useAppSelector(state => state.postOPSurgeonNotes.loading);
  const updating = useAppSelector(state => state.postOPSurgeonNotes.updating);
  const updateSuccess = useAppSelector(state => state.postOPSurgeonNotes.updateSuccess);

  const handleClose = () => {
    navigate(`/post-op-surgeon-notes${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getDoctors({}));
    dispatch(getNurses({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...postOPSurgeonNotesEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      anaesthesiologist: doctors.find(it => it.id.toString() === values.anaesthesiologist?.toString()),
      surgeon: doctors.find(it => it.id.toString() === values.surgeon?.toString()),
      scrubNurse: nurses.find(it => it.id.toString() === values.scrubNurse?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...postOPSurgeonNotesEntity,
          surgery: postOPSurgeonNotesEntity?.surgery?.id,
          anaesthesiologist: postOPSurgeonNotesEntity?.anaesthesiologist?.id,
          surgeon: postOPSurgeonNotesEntity?.surgeon?.id,
          scrubNurse: postOPSurgeonNotesEntity?.scrubNurse?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.postOPSurgeonNotes.home.createOrEditLabel" data-cy="PostOPSurgeonNotesCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.postOPSurgeonNotes.home.createOrEditLabel">
              Create or edit a PostOPSurgeonNotes
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="post-op-surgeon-notes-id"
                  label={translate('tinyMedicRestApp.postOPSurgeonNotes.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.preOpDiagnosis')}
                id="post-op-surgeon-notes-preOpDiagnosis"
                name="preOpDiagnosis"
                data-cy="preOpDiagnosis"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.postOpDiagnosis')}
                id="post-op-surgeon-notes-postOpDiagnosis"
                name="postOpDiagnosis"
                data-cy="postOpDiagnosis"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.diagnosisDiscrepancy')}
                id="post-op-surgeon-notes-diagnosisDiscrepancy"
                name="diagnosisDiscrepancy"
                data-cy="diagnosisDiscrepancy"
                type="text"
                validate={{
                  maxLength: { value: 1500, message: translate('entity.validation.maxlength', { max: 1500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.discrepancyNotes')}
                id="post-op-surgeon-notes-discrepancyNotes"
                name="discrepancyNotes"
                data-cy="discrepancyNotes"
                type="text"
                validate={{
                  maxLength: { value: 1500, message: translate('entity.validation.maxlength', { max: 1500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.incision')}
                id="post-op-surgeon-notes-incision"
                name="incision"
                data-cy="incision"
                type="text"
                validate={{
                  maxLength: { value: 1500, message: translate('entity.validation.maxlength', { max: 1500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.findings')}
                id="post-op-surgeon-notes-findings"
                name="findings"
                data-cy="findings"
                type="text"
                validate={{
                  maxLength: { value: 1500, message: translate('entity.validation.maxlength', { max: 1500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.procedure')}
                id="post-op-surgeon-notes-procedure"
                name="procedure"
                data-cy="procedure"
                type="text"
                validate={{
                  maxLength: { value: 3000, message: translate('entity.validation.maxlength', { max: 3000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.complications')}
                id="post-op-surgeon-notes-complications"
                name="complications"
                data-cy="complications"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.complicationNotes')}
                id="post-op-surgeon-notes-complicationNotes"
                name="complicationNotes"
                data-cy="complicationNotes"
                type="text"
                validate={{
                  maxLength: { value: 1500, message: translate('entity.validation.maxlength', { max: 1500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.closure')}
                id="post-op-surgeon-notes-closure"
                name="closure"
                data-cy="closure"
                type="text"
                validate={{
                  maxLength: { value: 1500, message: translate('entity.validation.maxlength', { max: 1500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.recovery')}
                id="post-op-surgeon-notes-recovery"
                name="recovery"
                data-cy="recovery"
                type="text"
                validate={{
                  maxLength: { value: 1500, message: translate('entity.validation.maxlength', { max: 1500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.specciman')}
                id="post-op-surgeon-notes-specciman"
                name="specciman"
                data-cy="specciman"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.active')}
                id="post-op-surgeon-notes-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.cursor')}
                id="post-op-surgeon-notes-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.lastupdated')}
                id="post-op-surgeon-notes-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.microSec')}
                id="post-op-surgeon-notes-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.timestampentry')}
                id="post-op-surgeon-notes-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="post-op-surgeon-notes-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="post-op-surgeon-notes-anaesthesiologist"
                name="anaesthesiologist"
                data-cy="anaesthesiologist"
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.anaesthesiologist')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="post-op-surgeon-notes-surgeon"
                name="surgeon"
                data-cy="surgeon"
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.surgeon')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="post-op-surgeon-notes-scrubNurse"
                name="scrubNurse"
                data-cy="scrubNurse"
                label={translate('tinyMedicRestApp.postOPSurgeonNotes.scrubNurse')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/post-op-surgeon-notes" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PostOPSurgeonNotesUpdate;
